import React from 'react'
import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Button,
	Row,
	Col
} from 'reactstrap'
import FontAwesome from 'react-fontawesome'


export default class ModalConfirm extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			showModal: false
		}
	}

	handleShowModal = () => {
		this.setState({ showModal: true })
	}

	handleConfirm = () => {
		this.props.handleConfirm()

		this.setState({ showModal: false })
	}

	handleCancel = () => {
		this.setState({ showModal: false })
	}

	render() {
		return (
			<React.Fragment>
				<Button
					onClick={this.handleShowModal}
					color="warning"
					block
					outline
				>
					Delete
				</Button>

				<Modal
					isOpen={this.state.showModal === true}
				>
					<ModalHeader>
						<FontAwesome name="exclamation-circle" />
						{' '}
						Please Confirm
					</ModalHeader>
					<ModalBody>
						{this.props.message}
					</ModalBody>
					<ModalFooter>
						<div>
							<Row>
								<Col sm={6}>
									<Button
										onClick={this.handleConfirm}
										color="success"
										block
									>
										<FontAwesome name="thumbs-up" />
										{' '}
										Confirm
									</Button>
								</Col>
								<Col sm={6}>
									<Button
										onClick={this.handleCancel}
										color="danger"
										block
									>
										<FontAwesome name="thumbs-down" />
										{' '}
										Cancel
									</Button>
								</Col>
							</Row>
						</div>
					</ModalFooter>
				</Modal>
			</React.Fragment>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/_core/deleteWithConfirm.jsx